import { memo, useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { StatusScreen } from 'shared/components';
import { APP_ROUTES } from 'shared/constants';
import { TenantContext } from 'shared/contexts';
import { useNavigateWithSearch } from 'shared/hooks';

function OfferError() {
    const { t } = useTranslation('candidateOffers');
    const { tenant } = useContext(TenantContext);
    const navigate = useNavigateWithSearch();

    const description = t('errorPage.general.description', {
        tenantName: tenant?.tenantName || 'Globus'
    });

    const handleOpenMainPage = useCallback(() => {
        navigate(APP_ROUTES.candidateOffers, {
            replace: true
        });
    }, [ navigate ]);

    return (
        <StatusScreen variant="error"
            title={ t('errorPage.general.title') }
            description={ description }
            buttonProps={{
                label: t('errorActions.openMainPage'),
                onClick: handleOpenMainPage,
                color: 'primary',
                size: 'medium'
            }}
        />
    );
}

export default memo(OfferError);
